import Swiper from 'swiper'

export default el => {
  new Swiper(el, {
    slidesPerView: 'auto',
    freeMode: true,
    mousewheel: true,
    grabCursor: true,
  })
}
